/**
 * Base URL for Payload's REST API from wherever the code is running.
 *
 * - On the server (SSR, Nitro routes) it is the internal address —
 *   `http://127.0.0.1:3001` on AWS, where Payload runs in the same container —
 *   so a render never leaves the instance, and an idle deployment slot talks to
 *   its own Payload rather than the live one through Cloudflare.
 * - In the browser it is host-relative in production, so a page served from
 *   any hostname (the canonical site, the SA host, the idle-slot host) calls
 *   the Payload behind that same host. In development Payload is on its own
 *   port, so the absolute public URL is kept there.
 *
 * `NUXT_PAYLOAD_INTERNAL_URL` overrides the internal address at runtime.
 */
export const payloadApiBase = (): string => {
  const config = useRuntimeConfig()
  const { siteUrl, payloadApiRoute, isDev } = config.public

  if (import.meta.server) {
    return `${config.payloadInternalUrl || siteUrl}${payloadApiRoute}`
  }

  return isDev ? `${siteUrl}${payloadApiRoute}` : payloadApiRoute
}
